import { translateFn } from '../../utils/translator.helper';
import { IntegrationConstraints } from '../constraints/IntegrationConstraints';

export function getIntegrationStrings(): object {
  return {
    detailsTitle: translateFn('Details'),

    integrationNameLabel: translateFn('Integration name'),
    hostNameLabel: translateFn('vCenter IP/Hostname'),

    usernameLabel: translateFn('Username'),
    userNameMaxLength: translateFn('Username must not be longer than {userNameMaxLength} characters.', {
      userNameMaxLength: IntegrationConstraints.Username.MaxLength,
    }),
    userNameMinLength: translateFn('Username must be at least {userNameMinLength} characters in length.', {
      userNameMinLength: IntegrationConstraints.Username.MinLength,
    }),
    invalidUserName: translateFn('Username contains characters that are not allowed.'),

    minPortValue: 1,
    maxPortValue: 65535,

    invalidPort: translateFn('Port must be a number between {minPortValue} and {maxPortValue}.', {
      minPortValue: 1,
      maxPortValue: 65535,
    }),
    portLabel: translateFn('Port'),

    invalidIntegrationName: translateFn('Name contains characters that are not allowed.'),

    integrationNameMaxLength: translateFn('Name must not be longer than {integrationNameMaxLength} characters.', {
      integrationNameMaxLength: IntegrationConstraints.IntegrationName.MaxLength,
    }),
    integrationNameMinLength: translateFn('Name must be at least {integrationNameMinLength} characters in length.', {
      integrationNameMinLength: IntegrationConstraints.IntegrationName.MinLength,
    }),

    invalidHostname: translateFn('Invalid hostname.'),

    passwordLabel: translateFn('Password'),
    passwordPlaceHolder: translateFn('Click here to change your password'),

    companySelectorLabel: translateFn('Company'),
  };
}
